import { render } from "./empty.vue?vue&type=template&id=59894a2e"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"

import "./empty.vue?vue&type=style&index=0&id=59894a2e&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-team/_components/empty.vue'],['render',render],['__file',"empty.vue"]])

export default __exports__